import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { AuthContext } from '../AuthContext';
import { friendshipAPI } from '../api';
import { t } from '../i18n';

const AddFriend = () => {
  const { user } = useContext(AuthContext);
  const [searchUserId, setSearchUserId] = useState('');
  const [message, setMessage] = useState('');
  
  const inviteUrl = `${window.location.origin}/invite/${user.username}`;

  const handleSendRequest = async (e) => {
    e.preventDefault();
    setMessage('');

    const username = searchUserId.trim();
    if (!username) {
      setMessage(t('pleaseEnterUsername'));
      return;
    }

    if (username === user.username) {
      setMessage(t('cannotFriendYourself'));
      return;
    }

    try {
      await friendshipAPI.sendRequest(username);
      setMessage(t('friendRequestSent'));
      setSearchUserId('');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || t('failedToSendRequest'));
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(inviteUrl);
    setMessage(t('linkCopied'));
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div className="container addfriend-page">
      <div style={{ marginBottom: '20px', marginTop: '12px' }}>
        <Link to="/friends" className="btn btn-secondary">{t('backToInvites')}</Link>
      </div>
      
      {message && (
        <div className="card" style={{ backgroundColor: message.includes(t('failedToSendRequest')) ? '#ffebee' : '#e8f5e9' }}>
          {message}
        </div>
      )}

      <div className="card">
        <h2>{t('sendFriendRequestByUsername')}</h2>
        <form onSubmit={handleSendRequest}>
          <div className="form-group" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input
              type="text"
              name="friend_search"
              aria-label="friend-search"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck="false"
              data-lpignore="true"
              inputMode="text"
              value={searchUserId}
              onChange={(e) => setSearchUserId(e.target.value)}
              placeholder={t('enterUsername')}
              required
              style={{ flex: 1 }}
            />
            <button type="submit" className="btn btn-primary">{t('send')}</button>
          </div>
        </form>
      </div>

      <div className="card invite-row">
        <div className="invite-qr">
          <h2>{t('yourInviteQrCode')}</h2>
          <div style={{ textAlign: 'center', padding: '0px' }}>
            <QRCodeSVG value={inviteUrl} size={256} />
          </div>
        </div>

        <div className="invite-link">
          <h2 style={{ marginTop: 0 }}>{t('inviteLink')}</h2>
            <p>{t('scanQrOrUseLink')}</p>
            <div className="copy-row" style={{ marginTop: '8px' }}>
              <a
                href={inviteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="link-anchor"
              >
                {inviteUrl}
              </a>
              <button className="btn btn-primary btn-icon" onClick={handleCopyLink} aria-label={t('copyInviteLink')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M16 1H4a2 2 0 0 0-2 2v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <rect x="8" y="7" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AddFriend;